import styled, { css } from "styled-components";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import * as CashPrice from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/CashPrice";
import * as MonthlyPrice from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/MonthlyPrice";
import * as ComboListStyles from "../../../../../../../common-deprecated/styles/v2/toyota/components/Combolist";
import * as TooltipStyles from "../../../../../../../common-deprecated/styles/v2/toyota/components/Tooltip";

export const Title = styled.h2`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 64px;
    margin-bottom: ${theme.space[3]}px;
    padding-bottom: ${theme.space[3]}px;
    font-family: ${theme.fonts.regular};
    font-size: 2.8rem;
    letter-spacing: 0;
    line-height: 3.2rem;
    text-align: start;
    text-transform: none;
    color: ${theme.colors.primaryBlack};
    border-bottom: 1px solid ${theme.colors.grey2};
`;

export const Description = styled.p`
    margin-bottom: ${theme.space[2]}px;
    font-family: ${theme.fonts.base};
    font-size: 1.6rem;
    letter-spacing: 0;
    line-height: 2.4rem;
    text-align: start;
    color: ${theme.colors.primaryBlack};
`;

export const List = styled.dl`
    display: flex;
    flex-wrap: wrap;
`;

const descriptionListStyle = css<{ withoutBorder?: boolean }>`
    width: 50%;
    margin: 0;
    padding: ${theme.space[2]}px 0;
    font-family: ${theme.fonts.base};
    font-size: 1.6rem;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 2.4rem;
    color: ${theme.colors.primaryBlack};
    border-bottom: 1px solid ${({ withoutBorder }) => (withoutBorder ? "transparent" : theme.colors.grey2)};
`;

export const DescriptionTerm = styled.dt<{ withoutBorder?: boolean }>`
    ${descriptionListStyle};
    text-align: start;

    ${TooltipStyles.PopoverButton} {
        margin-inline-start: ${theme.space[1]}px;
    }
`;

export const DescriptionDetail = styled.dd<{ hasLargeText?: boolean; withoutBorder?: boolean }>`
    ${descriptionListStyle};
    text-align: end;

    ${CashPrice.Text},
    ${MonthlyPrice.Text} {
        margin-top: 0;
    }

    ${({ hasLargeText }) =>
        hasLargeText &&
        css`
            font-family: ${theme.fonts.regular};
            font-size: 2rem;
            line-height: 2.4rem;
            ${CashPrice.Text},
            ${MonthlyPrice.Text} {
                font-family: ${theme.fonts.regular};
                font-size: 2rem;
                line-height: 2.4rem;
            }
            ${CashPrice.TextLineThrough} {
                font-size: 1.3rem;
                line-height: 2rem;
            }
        `};
`;

export const TaxLocationWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.space[1]}px;

    @media ${getBreakpoint("up", "md")} {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }

    ${ComboListStyles.ComboList} {
        position: static;
        top: auto;
        right: auto;
        max-width: none;
        border: 1px solid ${theme.colors.grey2};
        border-bottom: 0;
        box-shadow: none;
    }

    ${ComboListStyles.Wrapper} {
        ${ComboListStyles.Button} {
            justify-content: space-between;
        }
    }
`;
